module.exports = __webpack_public_path__ + "static/media/Linkedin_white.f2aa6211.svg";